import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("forensiq_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Super-admin only: send the active tenant selection so backend scopes reads/writes accordingly.
  const activeTenant = localStorage.getItem("forensiq_active_tenant");
  if (activeTenant) config.headers["X-Active-Tenant"] = activeTenant;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Don't yank kiosk viewers back to /login — the kiosk page has its own
    // token-in-URL model and never carries a Bearer.
    const isKioskPage = window.location.pathname.startsWith("/kiosk");
    if (err.response?.status === 401 && !window.location.pathname.startsWith("/login") && !isKioskPage) {
      localStorage.removeItem("forensiq_token");
      localStorage.removeItem("forensiq_user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

// Standalone axios instance for kiosk pages — no auth interceptor.
export const kioskApi = axios.create({ baseURL: API_BASE });
